import { getTypes } from '../../services/journal/types.service'

// MF-67 — Journal types list slice.
export const UPDATE_JOURNAL_TYPES_LIST = 'UPDATE_JOURNAL_TYPES_LIST'
export const TOGGLE_JOURNAL_TYPES_LOADING = 'TOGGLE_JOURNAL_TYPES_LOADING'
export const JOURNAL_TYPES_ERROR = 'JOURNAL_TYPES_ERROR'
export const JOURNAL_TYPES_UPDATE_TOTAL = 'JOURNAL_TYPES_UPDATE_TOTAL'

export const updateTypesList = (value = []) => ({
  type: UPDATE_JOURNAL_TYPES_LIST,
  payload: { value }
})

export const typesError = (value = null) => ({
  type: JOURNAL_TYPES_ERROR,
  payload: { value }
})

export const toggleLoadingTypes = (value = false) => ({
  type: TOGGLE_JOURNAL_TYPES_LOADING,
  payload: { value }
})

export const updateTotalTypes = (value = 0) => ({
  type: JOURNAL_TYPES_UPDATE_TOTAL,
  payload: { value }
})

export const loadTypes = (params = {}) => {
  return async (dispatch) => {
    try {
      dispatch(toggleLoadingTypes(true))
      dispatch(typesError())

      const { data } = await getTypes(params)

      dispatch(updateTypesList(data?.paginatedResults ?? []))
      dispatch(updateTotalTypes(data?.totalRecords ?? 0))
    } catch (error) {
      dispatch(updateTypesList([]))
      dispatch(updateTotalTypes(0))
      dispatch(typesError(error?.message ?? 'error'))
    } finally {
      dispatch(toggleLoadingTypes(false))
    }
  }
}
